import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Condition } from 'Component/others';
import { PlusIcon } from 'Asset/icon';
import { getMenuPermissions } from 'Helper/getMenuPermissions';
import ButtonSolid from 'UiKit/button/buttonSolid';
import SearchComponent from 'UiKit/search';
import { useRoleState } from 'View/role/state';

import styles from './styles.module.css';

const Filter = () => {
  const { t } = useTranslation('role');
  const accessPermission = getMenuPermissions('master-data', 'access');
  const navigate = useNavigate();

  const { updateFilterState } = useRoleState();
  const onChangeFilter = (newFilter) => updateFilterState({ page: 1, search: newFilter });

  return (
    <Box className={styles['filter__wrapper']}>
      <Flex className={styles['filter__container']}>
        <SearchComponent maxWidth="337px" onSearch={onChangeFilter} />

        <Condition statement={accessPermission?.isCanCreate}>
          <ButtonSolid
            type="button"
            className={styles['create__button']}
            leftIcon={<PlusIcon width="14px" height="14px" mt="2px" color="var(--color-semantic-white)" />}
            onClick={() => navigate('/master-data/access/upsert')}
          >
            {t('createButton')}
          </ButtonSolid>
        </Condition>
      </Flex>
    </Box>
  );
};

export default Filter;